// «Просрочено у ваших сотрудников» (032: contracts/api.md, team.overdue; FR-021, FR-022;
// ASG-FLOW-04; поправка XII 2.7.0; research Р6). Только чтение: люди руководителя по дереву
// подразделений и их открытые просроченные пункты. Название протокола не отдаётся — только номер
// «П-12»: протокол руководителю не открывается.
import { z } from '../kernel/zod.ts';
import { DateSchema, IdSchema, TimestampSchema } from '../kernel/common.ts';
import { ItemAnswerKindSchema } from '../minutes/answers.ts';

export const TeamItemSchema = z.object({
  itemId: IdSchema,
  /** Номер пункта, как в протоколе: «3.2». */
  number: z.string(),
  /** «Что сделать». */
  title: z.string(),
  /** Номер протокола: 12 → «П-12». */
  documentNumber: z.number().int().min(1),
  dueRaw: z.string(),
  /** Конец срока ГГГГ-ММ-ДД. */
  dueEnd: DateSchema,
  /** Рабочих дней просрочки (календарь 031). */
  overdueDays: z.number().int().min(1),
  /** Последний неотменённый ответ ответственного; нет — null. */
  lastAnswer: z.object({ kind: ItemAnswerKindSchema, at: TimestampSchema }).nullable(),
});
export type TeamItem = z.infer<typeof TeamItemSchema>;

/** GET /api/team/overdue: не руководитель — пустой список, не отказ. */
export const TeamOverdueSchema = z.object({
  people: z.array(
    z.object({ personId: IdSchema, name: z.string(), items: z.array(TeamItemSchema).min(1) }),
  ),
});
export type TeamOverdue = z.infer<typeof TeamOverdueSchema>;
